<template>
  <div class="notification_routes">
    <div class="wrap-device-list_bg">
      <div
          class="main_filters"
          :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
          @click="toggleFiltersState"
      >
        <span
            class="mdi"
            :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
        />
        <span class="main_fiters_toggler_text">
          {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
        </span>
      </div>
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <tree-select
            v-model="filter.service_key"
            :options="service_list"
            :placeholder="translate('telegram.service')"
            :disabled="catalog_loading"
            @input="change_service"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.event_key"
            :options="event_list"
            :placeholder="translate('telegram.event')"
            :disabled="!filter.service_key || catalog_loading"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.audience"
            :options="audience_list"
            :placeholder="translate('telegram.audience')"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.client_id"
            :options="client_list"
            :placeholder="translate('client.one')"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <fg-input
            v-model="filter.destination_id"
            :placeholder="translate('telegram.destination_id')"
            :clearable="true"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <tree-select
            v-model="filter.is_active"
            :options="state_list"
            :placeholder="translate('telegram.rule_state')"
            @input="change_input"
          />
        </div>
        <div class="form_select">
          <fg-input
            v-model="filter.q"
            :placeholder="translate('search')"
            :clearable="true"
            @input="change_input"
          />
        </div>
      </div>
    </div>
    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>
      <h3 v-else-if="!route_list.length" class="text-center">{{ translate('no_data') }}</h3>
      <table v-else>
        <thead>
          <tr>
            <th
              v-for="column in columns"
              :key="column"
              scope="col"
            >
              {{ translate('telegram.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in route_list"
            :key="item.id"
          >
            <td
              class="text-left"
              :data-label="translate('telegram.service')"
            >
              <p>{{ item.service_name || services[item.service_key]?.name }}</p>
              <small>{{ item.service_key }}</small>
            </td>
            <td
              class="text-left"
              :data-label="translate('telegram.event')"
            >
              <p>
                {{ item.event_name || services[item.service_key]?.events?.[item.event_key]?.name }}
              </p>
              <small>{{ item.service_key }}/{{ item.event_key }}</small>
            </td>
            <td :data-label="translate('telegram.audience')">
              {{
                translate(item.audience === 'internal' ? 'telegram.internal' : 'telegram.client')
              }}
            </td>
            <td :data-label="translate('client.one')">
              {{
                item.audience === 'internal'
                  ? translate('telegram.internal')
                  : recipient(item.client_id, item.client_name)
              }}
            </td>
            <td :data-label="translate('telegram.channel')">
              {{ item.destination?.name || translate('telegram.missing_channel') }}
            </td>
            <td data-label="Chat ID">{{ item.destination?.chat_id }}</td>
            <td data-label="Thread ID">
              {{
                item.destination
                  ? item.destination.thread_id || translate('telegram.no_thread')
                  : ''
              }}
            </td>
            <td :data-label="translate('telegram.rule_state')">
              {{ translate(active(item.is_active) ? 'telegram.active' : 'telegram.disabled') }}
            </td>
            <td :data-label="translate('telegram.channel_state')">
              {{
                item.destination
                  ? translate(
                      active(item.destination.is_active) ? 'telegram.active' : 'telegram.disabled'
                    )
                  : translate('telegram.missing_channel')
              }}
            </td>
            <td
              :data-label="translate('telegram.delivery')"
              :class="active(item.delivery_enabled) ? 'text-success' : 'text-danger'"
            >
              {{ delivery_status(item) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination_controls" v-if="!loading">
      <span>{{ translate('telegram.total') }}: {{ total }}</span>
      <button
        class="btn btn-info btn-fill"
        :disabled="loading || filter.offset === 0"
        @click="change_page(Math.max(0, filter.offset - filter.limit))"
      >
        {{ translate('telegram.previous') }}
      </button>
      <span>{{ Math.floor(filter.offset / filter.limit) + 1 }}</span>
      <button
        class="btn btn-info btn-fill"
        :disabled="loading || filter.offset + filter.limit >= total"
        @click="change_page(filter.offset + filter.limit)"
      >
        {{ translate('telegram.next') }}
      </button>
      <tree-select
        v-model="filter.limit"
        :options="[50, 100, 250, 500].map((value) => ({id: value, label: String(value)}))"
        :clearable="false"
        :disabled="loading"
        @input="change_page(0)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotificationRoutes',
  data () {
    return {
      route_list: [],
      total: 0,
      loading: true,
      timer: null,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter: {
        service_key: null,
        event_key: null,
        audience: null,
        client_id: null,
        destination_id: null,
        is_active: null,
        q: '',
        limit: 50,
        offset: 0
      },
      services: {},
      catalog_loading: false,
      columns: [
        'service',
        'event',
        'audience',
        'client',
        'channel',
        'chat_id',
        'thread_id',
        'rule_state',
        'channel_state',
        'delivery'
      ]
    }
  },
  computed: {
    client_list() {
      return [
        {id: 0, label: this.translate('telegram.internal')},
        ...this.$store.getters.getClientsList.map((client) => ({
          id: Number(client.id),
          label: client.name
        }))
      ]
    },
    state_list() {
      return [
        {id: 1, label: this.translate('telegram.active')},
        {id: 0, label: this.translate('telegram.disabled')}
      ]
    },
    sended_filter() {
      let filter = {}
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] !== '' && this.filter[key] !== null && this.filter[key] !== undefined) {
          filter[key] = this.filter[key]
        }
      })
      return filter
    },
    service_list() {
      return Object.keys(this.services).map((key) => ({id: key, label: this.services[key].name}))
    },
    event_list() {
      const events = this.services[this.filter.service_key]?.events || {}
      return Object.keys(events).map((key) => ({id: key, label: events[key].name}))
    },
    audience_list() {
      return [
        {id: 'internal', label: this.translate('telegram.internal')},
        {id: 'client', label: this.translate('telegram.client')}
      ]
    }
  },
  created () {
    this.check_query()
    this.get_catalog()
  },
  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'notification_section') {
          let string = '?'
          for (let key in this.filter) {
            if (key === 'limit' || key === 'offset') continue
            if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
              string += '&' + key + '=' + encodeURIComponent(this.filter[key])
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    active(value) {
      return value === true || value === 1 || value === '1'
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
            case 'is_active':
            case 'destination_id':
              this.filter[key] = Number(this.$route.query[key])
              break;
            case 'q':
            case 'service_key':
            case 'event_key':
            case 'audience':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
      this.get_routes()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.filter.offset = 0
      this.timer = setTimeout(this.get_routes, 500)
    },
    change_page(offset) {
      clearTimeout(this.timer)
      this.filter.offset = offset
      this.get_routes()
    },
    get_routes(){
      this.loading = true
      this.$http.v1.getNotificationRoutes(this.sended_filter, (response) => {
        if (response.data){
          this.route_list = response.data.items
          this.total = response.data.total
          this.filter.limit = response.data.limit
          this.filter.offset = response.data.offset
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
    recipient(client_id, name) {
      if (!client_id) return this.translate('telegram.internal')
      const client = this.$store.getters.getClientsList.find(
        (client) => String(client.id) === String(client_id)
      )
      return `${name || client?.name || this.translate('client.one')} #${client_id}`
    },
    change_service() {
      this.filter.event_key = null
      this.change_input()
    },
    get_catalog(){
      this.catalog_loading = true
      this.$http.v1.getNotificationRouteCatalog((response) => {
        if (response.data){
          this.services = response.data.services
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      }).finally(() => {
        this.catalog_loading = false
      })
    },
    delivery_status(item) {
      if (this.active(item.delivery_enabled)) return this.translate('telegram.delivery_enabled')
      if (!item.destination) return this.translate('telegram.missing_channel')
      if (!this.active(item.destination.is_active))
        return this.translate('telegram.channel_disabled')
      if (!this.active(item.is_active)) return this.translate('telegram.route_disabled')
      if (item.is_supported === false) return this.translate('telegram.unsupported')
      return this.translate('telegram.delivery_disabled')
    }
  }
}
</script>
<style lang="scss" scoped>
.notification_routes {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin: 0;
      }
      .btn{
        width: 100%;
      }
    }
  }

  .response_table {
    flex: 10;
    padding: 10px 0 0;
    th,
    td {
      font-size: 12px;
      vertical-align: middle;
    }
    .text-left {
      text-align: left;
    }
    td p {
      font-size: 12px;
      margin: 0;
    }
    tbody tr:hover {
      background-color: #eee;
    }
  }
  .pagination_controls {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-top: 10px;
    .vue-treeselect {
      width: 100px;
    }
  }
}
</style>
